"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAVING = exports.LOADING = exports.UNAVAILABLE = exports.AVAILABLE = exports.NOT_LOADED = void 0;
/*
 * Fancy ASCII diagram for how these states work:
 *
 *  −→ NOT_LOADED
 *         ↓
 *      LOADING ←→ UNAVAILABLE
 *         ↓           ↑
 *     AVAILABLE ←−→ SAVING
 */
// Stable states

var NOT_LOADED = 'NOT_LOADED';
exports.NOT_LOADED = NOT_LOADED;
var AVAILABLE = 'AVAILABLE';
exports.AVAILABLE = AVAILABLE;
var UNAVAILABLE = 'UNAVAILABLE'; // Transition states

exports.UNAVAILABLE = UNAVAILABLE;
var LOADING = 'LOADING';
exports.LOADING = LOADING;
var SAVING = 'SAVING';
exports.SAVING = SAVING;